import script from "./FileUploadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadComponent.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadComponent.vue?vue&type=style&index=0&id=732b33e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732b33e2"]])

export default __exports__